import analyticsService from "../services/analyticsService";
import graphqlMutationService from "../services/graphqlMutationService";
import graphqlQueryService from "../services/graphqlQueryService";
import RootStore from "./RootStore";

export const createRootStoreInstance = () =>
  new RootStore({
    analyticsService,
    graphqlMutationService,
    graphqlQueryService
  });

export default createRootStoreInstance();
